// ============================================================
// Datei: src/pages/ressorts/Infrastruktur.jsx
// 🔥 FIX:
// - reloadVolunteers abgesichert
// - KEIN Doppel-Modal mehr
// ============================================================

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "../../../styles/global.css";
import "../../../styles/ressortTabs.css";
import "../../../styles/ccMailCard.css";

import useVolunteers from "../../../components/fetch/useVolunteers";
import useShifts from "../../../components/fetch/useShifts";
import Api from "../../../Api";

import InfrastrukturDesktop from "./InfrastrukturDesktop";
import InfrastrukturMobile from "./InfrastrukturMobile";
import useMediaQuery from "../../../hooks/useMediaQuery";

const Infrastruktur = () => {

	const isMobile = useMediaQuery("(max-width: 768px)");
	const navigate = useNavigate();

	// ============================================================
	// VOLUNTEERS
	// ============================================================

	const volunteersHook = useVolunteers("Infrastruktur");

	const volunteers = volunteersHook[0];
	const setVolunteers = volunteersHook[1];

	// 🔥 FIX: Fallback wie in allen anderen Ressorts
	const reloadVolunteers =
		typeof volunteersHook[2] === "function"
			? volunteersHook[2]
			: async () => {
				try {
					const res = await Api.get("/volunteers?department=Infrastruktur");
					setVolunteers([...res.data]);
				} catch (err) {
					console.error("❌ Reload Volunteers Fehler:", err);
				}
			};

	const [shifts] = useShifts("Infrastruktur");

	const [selectedVolunteer, setSelectedVolunteer] = useState(null);
	const [guests, setGuests] = useState([]);
	const [activeTab, setActiveTab] = useState("overview");

	// ============================================================
	// SECURITY
	// ============================================================

	useEffect(() => {
		const role = localStorage.getItem("role");
		const dept = localStorage.getItem("department");

		if (role !== "OK" || dept?.toLowerCase() !== "infrastruktur") {
			alert("Zugriff verweigert!");
			navigate("/home");
			return;
		}

		loadGuests();
	}, [navigate]);

	const loadGuests = () => {
		Api.get("/guests").then(res => setGuests(res.data));
	};

	// ============================================================
	// CC DOWNLOAD
	// ============================================================

	const downloadCcEmails = async () => {
		try {
			const res = await Api.get("/cc-emails", { responseType: "blob" });

			const blob = new Blob([res.data], { type: "text/plain" });
			const url = URL.createObjectURL(blob);

			const a = document.createElement("a");
			a.href = url;
			a.download = "helferfest_cc_liste.txt";
			a.click();

			URL.revokeObjectURL(url);
		} catch (err) {
			console.error(err);
			alert("Download fehlgeschlagen");
		}
	};

	// ============================================================
	// PROPS
	// ============================================================

	const layoutProps = {
		volunteers,
		setVolunteers,
		reloadVolunteers, // 🔥 wichtig

		shifts,
		guests,
		selectedVolunteer,
		setSelectedVolunteer,
		activeTab,
		setActiveTab,
		reloadGuests: loadGuests,
		downloadCcEmails
	};

	return (
		<div
			className="infrastruktur-page bg-reveal"
			data-bg={`${process.env.PUBLIC_URL}/backgrounds/background_infrastruktur.png`}
		>
			<h2 className="infrastruktur-heading">Infrastruktur</h2>

			{isMobile
				? <InfrastrukturMobile {...layoutProps} />
				: <InfrastrukturDesktop {...layoutProps} />
			}
		</div>
	);
};

export default Infrastruktur;